import { EColors } from "../../../../types/styles/colors.enum"
import { IconProps } from "./sendIcon.component"

const CloneIcon: React.FC<IconProps> = ({ colorCode = EColors.text, ...props }) => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><path fill="none" stroke="currentColor" strokeWidth="2" d="M7 23h16V7H7zM17 4V1h-3M1 14v3h3m-3-5V6zM4 1H1v3m5-3h6z"/></svg>
    )
  }
  export default CloneIcon;